import { SET_ACCOUNT } from '../actions/types';

const initialState = {
	name: '',
};

export default function account(state = initialState, action) {
	if (!action.error && action.payload) {
		switch (action.type) {
			case SET_ACCOUNT:
				return { ...state, ...action.payload };
			default:
		}
	}
	return state;
}



// WEBPACK FOOTER //
// ./src/reducers/account.js